const urls = {
    //API URLS
    'version': '/api/',
    'account': '/api/account/user/',
    'login': '/api/account/login/',
    'logout': '/api/account/logout/',
    'password_reset': '/api/account/password/reset/',
    'two_factor_device': '/api/account/two_factor/',
    'files': '/api/files/',
    'multipart_upload': '/api/files/upload/',

    //Django Template Urls (used for the parts that are not part of the spa, or are remote sites)
    'password_change': '/account/password_change/',
    'admin_site': '/admin/',
    'main_site': 'https://www.heatremotesensing.com/',
};

export default {...urls,
    data: function () { return {
        'urls': urls
    }},
};
